import { getTexture } from "../Services/transferData";

export const getAllTexture = () => {
  return async (dispatch) => {
    const { data } = await getTexture();
    await dispatch({ type: "GET_TEXTURE", payload: data });
  };
};

export const updateAllTexture = (data) => {
  return async (dispatch,getState) => {
      const updtState = [...getState().texture];
      updtState[2] = [...new Set([...updtState[2],...data])];
      await dispatch({type:"UPDATE_TEXTURE",payload:updtState});
  }
}